import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  background-color: ${({theme}) => theme.background};
  height: 100%;
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  z-index: 10;
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  
  .icon {
    color: ${({ theme }) => theme.arrowBack};
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(-2px);
  }
`;

export const TitleContainer = styled.div`
  margin-top: 50px;
  max-width: 100%;
  width: 100%;
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 32px;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  color: ${props => props.theme.textSubtitleCompliance};
  margin: 8px 0 32px 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
`;

export const DropzoneContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const DropzoneArea = styled.div`
  width: 100%;
  height: 350px;
  border: 5px dashed ${({ theme }) => theme.borderLight};
  border-radius: 15px;
  background-color: ${({theme}) => theme.dropzoneBackground || 'transparent'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: border-color 0.2s ease;
  margin-bottom: 24px;
  padding: 20px;
  box-sizing: border-box;
  
  &:hover {
    border-color: ${({ theme }) => theme.primaryAccent};
  }
  
  &.active {
    border-color: ${({ theme }) => theme.primaryAccent};
    background-color: ${({theme}) => theme.dropzoneActiveBackground || '${({ theme }) => alpha(theme.primary, 0.05)}'};
  }
  
  &.file-loaded {
    cursor: default;
    border-color: ${({ theme }) => theme.primaryAccent};
  }
`;

export const DropzoneText = styled.p`
  color: ${props => props.theme.text};
  margin: 8px 0;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
`;

export const OrText = styled.p`
  color: ${props => props.theme.text};
  margin: 24px 0;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
`;

export const UploadButton = styled.button`
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 4px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
  
  &:disabled {
    background-color: ${({ theme }) => theme.primary};
    cursor: not-allowed;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0;
  
  span {
    color: ${props => props.theme.text};
    font-size: 14px;
    margin-top: 4px;
    opacity: 0.7;
  }
`;

export const FileName = styled.div`
  color: ${props => props.theme.text};
  font-size: 16px;
  font-weight: 500;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: ${props => props.theme.text};
`;

export const SuccessMessage = styled.p`
  color: ${({ theme }) => theme.success};
  font-size: 18px;
  font-weight: 600;
  margin: 8px 0;
  text-align: center;
`; 